import { defineStore } from "pinia";

export const useConnectionStore = defineStore('connectionStore', {
  state : () => ({
    cookie : null,
    dummy : null,

    isSubscriber : null,
    subscriberExpireDate : null,
    subscriberExpireDisplayString : null,
    lastStartupCheckDate : null,
    coordinateLocation : null,
    fileWords : null,
    verified : null,

    // darkmode - set by system for overall screen.
    darkmode : null,
    boardColors : null,

    email : null,
    isMe : null,
    canPerpetual : null,

    lichessAccessToken : null,
    lichessUserid : null,
    lichessGameId : null,
    lichessFriendId : "",
    lichessFriendName : "",

    // type of play (or string to pass with router)
    playType : "",
    playComputerGameId : null,
    reviewGameId : null,

    // home page for www.verbalchess.fun
    verbalHomePage : "",

    seenTour : null,
    previouslySeenProgramVersion : null,
    
    microphoneIsMuted : false,

    verbalVersion : import.meta.env.VITE_APP_VERSION,

    deviceType : null,
    toolbarHeight : null,
    topIndent : null,
    leftIndent : null,

    // use verbalchess.fun and the redirect program to get to the php files
    //.    if false, it is in a subdirectory within chessvis
    useVerbalWebsite : true,

    // this resolves the "system" language requested
    languageInUse : null,
    languageIncludingSystem : null,

    playerMp3Name : null,
    playerMp3Lang : null,
    playerMp3Vendor : null,
    opponentMp3Name : null,
    opponentMp3Lang : null,
    opponentMp3Vendor : null,

    // start on the landing page
    startOnLandingPage : null,
    runRequestFromLandingPage : null,

    // track if audio is playing and if not show a button
    audioCanBeHeard : false,

    // play friends
    friendOptions : null,
    friendOpenGame : null,

    welcomeMp3URL : null

  }),
  getters: {
    getWelcomeMp3URL() {
      // return back the english if not set
      switch (this.languageInUse) {
        case "es" :
          this.welcomeMp3URL = "https://www.verbalchess.fun/say/google/es-ES/es-ES-Wavenet-F/Bienvenido_a_Verbal_Chess.mp3"
          break
        case "fr" :
          this.welcomeMp3URL = "https://www.verbalchess.fun/say/google/fr-FR/fr-FR-Wavenet-F/Bienvenue_sur_Verbal_Chess.mp3"
          break
        case "it" :
          this.welcomeMp3URL = "https://www.verbalchess.fun/say/google/it-IT/it-IT-Wavenet-E/Benvenuto_a_Verbal_Chess.mp3"
          break
        case "de" :
          this.welcomeMp3URL = "https://www.verbalchess.fun/say/google/de-DE/de-DE-Wavenet-G/Willkommen_bei_Verbal_Chess.mp3"
          break
        case "pt" :
          this.welcomeMp3URL = "https://www.verbalchess.fun/say/google/pt-PT/pt-PT-Wavenet-E/Bem-vindo_ao_Verbal_Chess.mp3"
          break
        default :
          this.welcomeMp3URL = "https://www.verbalchess.fun/say/google/en-US/en-US-Wavenet-C/Welcome_to_Verbal_Chess.mp3"
          break
        }
      return this.welcomeMp3URL
    },
    getFriendOpenGame() {
      if (this.friendOpenGame == null) {
        const jsonString = localStorage.getItem("friendOpenGame")
        if (jsonString != null)
          this.friendOpenGame = JSON.parse(jsonString)
      }
      if (this.friendOpenGame == null) {
        this.friendOpenGame = {
          open : false
        }
      }
      return this.friendOpenGame
    },
    getFriendOptions() {
      if (this.friendOptions == null) {
        const jsonString = localStorage.getItem("friendOptions")
        if (jsonString != null)
          this.friendOptions = JSON.parse(jsonString)
      }
      if (this.friendOptions == null) {
        this.friendOptions = {
          color : "white",
          blindness : 1,
          playKeyword : "no",
          orientation : "manual"
        }
      }
      return this.friendOptions
    },

    getAudioCanBeHeard() {
      return this.audioCanBeHeard
    },
    getRunRequestFromLandingPage() {
      if (this.runRequestFromLandingPage == null)
        this.runRequestFromLandingPage = localStorage.getItem("runRequestFromLandingPage")
      if (this.runRequestFromLandingPage == null)
        this.runRequestFromLandingPage = "no"
      return this.runRequestFromLandingPage
    },
    getStartOnLandingPage() {
      if (this.startOnLandingPage == null)
        this.startOnLandingPage = localStorage.getItem("startOnLandingPage")
      if (this.startOnLandingPage == null)
        this.startOnLandingPage = "yes"
      return this.startOnLandingPage
    },
    getUseVerbalWebsite() {
      return this.useVerbalWebsite
    },
    getLanguageInUse() {
      if (this.languageInUse == null)
        this.languageInUse = localStorage.getItem("languageInUse")
      if (this.languageInUse == null)
        this.languageInUse = ""
      return this.languageInUse
    },
    getLanguageIncludingSystem() {
      if (this.languageIncludingSystem == null)
        this.languageIncludingSystem = localStorage.getItem("languageIncludingSystem")
      if (this.languageIncludingSystem == null)
        this.languageIncludingSystem = ""
      return this.languageIncludingSystem
    },
    getDeviceType() {
      if (this.deviceType == null)
        this.deviceType = localStorage.getItem("deviceType")
      if (this.deviceType == null)
        this.deviceType = "web"
      return this.deviceType
    },
    getToolbarHeight() {
      if (this.toolbarHeight == null)
        this.toolbarHeight = localStorage.getItem("toolbarHeight")
      if (this.toolbarHeight == null)
        this.toolbarHeight = "50"
      return this.toolbarHeight
    },
    getMicrophoneIsMuted() {
      //console.log("in get ",this.microphoneIsMuted)
      return (this.microphoneIsMuted)
    },
    getExplainTourWords() {
      return ("command next back new general done scroll down up mute listen english translated")
    },
    getVersion() {
      return (this.verbalVersion)
    },
    getPreviouslySeenProgramVersion() {
      if (this.previouslySeenProgramVersion == null)
        this.previouslySeenProgramVersion = localStorage.getItem("previouslySeenProgramVersion")
      if (this.previouslySeenProgramVersion == null)
        this.previouslySeenProgramVersion = "0.0.0"
      return (this.previouslySeenProgramVersion)
    },
    getSeenTour() {
      if (this.seenTour == null)
        this.seenTour = localStorage.getItem("seenTour")
      if (this.seenTour == null)
        this.seenTour = "n"
      return (this.seenTour)
    },
    getFileWords() {
      if (this.fileWords == null)
        this.fileWords = localStorage.getItem("fileWords")
      if (this.fileWords == null)
        this.fileWords = "letters"
      return (this.fileWords)
    },
    getCoordinateLocation() {
      if (this.coordinateLocation == null)
        this.coordinateLocation = localStorage.getItem("coordinateLocation")
      if (this.coordinateLocation == null)
        this.coordinateLocation = "in"
      return (this.coordinateLocation)
    },
    getIsSubscriber() {
      if (this.isSubscriber == null)
        this.isSubscriber = localStorage.getItem("isSubscriber")
      if (this.isSubscriber == null || this.isSubscriber != "1")
        this.isSubscriber = "0"
      return (this.isSubscriber)
    },
    getSubscriberExpireDate() {
      if (this.subscriberExpireDate == null)
        this.subscriberExpireDate = localStorage.getItem("subscriberExpireDate")
      if (this.subscriberExpireDate == null)
        this.subscriberExpireDate = 0
      return (this.subscriberExpireDate)
    },
    getSubscriberExpireDisplayString() {
      if (this.subscriberExpireDisplayString == null)
        this.subscriberExpireDisplayString = localStorage.getItem("subscriberExpireDisplayString")
      if (this.subscriberExpireDisplayString == null)
        this.subscriberExpireDisplayString = ""
      return (this.subscriberExpireDisplayString)
    },
    getIsMe() {
      if (this.isMe == null)
        this.isMe = localStorage.getItem("isMe")
      if (this.isMe == null)
        this.isMe = "0"
      return this.isMe
    },
     getCanPerpetual() {
      if (this.canPerpetual == null)
        this.canPerpetual = localStorage.getItem("canPerpetual")
      if (this.canPerpetual == null)
        this.canPerpetual = "n"
      return this.canPerpetual
    },
    getPlayerMp3Name() {
      if (this.playerMp3Name == null)
        this.playerMp3Name = localStorage.getItem("playerMp3Name")
      if (this.playerMp3Name == null)
        this.playerMp3Name = ""
      
      return this.playerMp3Name
    },
    getPlayerMp3Lang() {
      if (this.playerMp3Lang == null)
        this.playerMp3Lang = localStorage.getItem("playerMp3Lang")
      if (this.playerMp3Lang == null)
        this.playerMp3Lang = ""
      return this.playerMp3Lang
    },
    getPlayerMp3Vendor() {
      if (this.playerMp3Vendor == null)
        this.playerMp3Vendor = localStorage.getItem("playerMp3Vendor")
      if (this.playerMp3Vendor == null)
        this.playerMp3Vendor = ""
      return this.playerMp3Vendor
    },
    getOpponentMp3Name() {
      if (this.opponentMp3Name == null)
        this.opponentMp3Name = localStorage.getItem("opponentMp3Name")
      if (this.opponentMp3Name == null)
        this.opponentMp3Name = ""
      return this.opponentMp3Name
    },
    getOpponentMp3Lang() {
      if (this.opponentMp3Lang == null)
        this.opponentMp3Lang = localStorage.getItem("opponentMp3Lang")
      if (this.opponentMp3Lang == null)
        this.opponentMp3Lang = ""
      return this.opponentMp3Lang
    },
    getOpponentMp3Vendor() {
      if (this.opponentMp3Vendor == null)
        this.opponentMp3Vendor = localStorage.getItem("opponentMp3Vendor")
      if (this.opponentMp3Vendor == null)
        this.opponentMp3Vendor = ""
      return this.opponentMp3Vendor
    },
    getEmailVerified() {
      if (this.verified == null)
        this.verified = localStorage.getItem("emailVerified")
      if (this.verified == null)
        this.verified = "no"
      return this.verified
    },
    getEmailAddress() {
      if (this.email == null)
        this.email = localStorage.getItem("email")
      if (this.email == null)
        this.email = ""
      return this.email
    },
    getCookie() {
      //console.log("IN GET COOKIE",localStorage.getItem("cookie"))
      if (this.cookie == null)
        this.cookie = localStorage.getItem("cookie")
      if (this.cookie == null)
        this.cookie = ""

      return this.cookie
    },
    getDummy() {
      if (this.dummy == null)
        this.dummy = localStorage.getItem("dummy")
      if (this.dummy == null)
        this.dummy = "1"
      return this.dummy
    },
    getBoardColors() {
      if (this.boardColors == null)
        this.boardColors = localStorage.getItem("boardColors")
      if (this.boardColors == null)
        this.boardColors = "light"
      return this.boardColors
    },
    getDarkmode() {
      // see if darkmode already set, also fix any old values
      if (this.darkmode == null)
        this.darkmode = localStorage.getItem("dark")
      if (this.darkmode == null || this.darkmode == "n" || this.darkmode == "")
        this.darkmode = "light"
      else
      if (this.darkmode == "y")
        this.darkmode = "dark"
      return (this.darkmode)
    },
    getLastStartupCheckDate() {
      if (this.lastStartupCheckDate == null)
        this.lastStartupCheckDate = localStorage.getItem("lastStartupCheckDate")
      if (this.lastStartupCheckDate == null)
        this.lastStartupCheckDate = "0"
      return this.lastStartupCheckDate
    },
    getPlayType() {
      this.playType = localStorage.getItem("playType")
      return this.playType
    },
    getPlayComputerGameId() {
      if (this.playComputerGameId == null)
        this.playComputerGameId = localStorage.getItem("playComputerGameId")
      if (this.playComputerGameId == null)
        this.playComputerGameId = "0"
      return this.playComputerGameId
    },
    getReviewGameId() {
      if (this.reviewGameId == null)
        this.reviewGameId = localStorage.getItem("reviewGameId")
      if (this.reviewGameId == null)
        this.reviewGameId = "0"
      return this.reviewGameId
    },
    getLichessGameId() {
      if (this.lichessGameId == null)
        this.lichessGameId = localStorage.getItem("lichessGameId")
      if (this.lichessGameId == null)
        this.lichessGameId = ""
      return this.lichessGameId
    },
    getLichessAccessToken() {
      if (this.lichessAccessToken == null)
        this.lichessAccessToken = localStorage.getItem("lichessAccessToken")
      if (this.lichessAccessToken == null)
        this.lichessAccessToken = ""
      return (this.lichessAccessToken)
    },
    getLichessUserid() {
      if (this.lichessUserid == null)
        this.lichessUserid = localStorage.getItem("lichessUserid")
      if (this.lichessUserid == null)
        this.lichessUserid = ""
      return (this.lichessUserid)
    },
    getLichessFriend() {
      this.lichessFriendId = localStorage.getItem("lichessFriendId")
      this.lichessFriendName = localStorage.getItem("lichessFriendName")
      return { id : this.lichessFriendId , name : this.lichessFriendName }
    },
    getVerbalHomePage() {
      this.verbalHomePage = localStorage.getItem("verbalHomePage")
      return this.verbalHomePage
    }
  },
  actions: {
    setWelcomeMp3URL(welcomeMp3URL) {
      this.welcomeMp3URL = welcomeMp3URL
      localStorage.setItem("welcomeMp3URL",welcomeMp3URL)
    },
    setFriendOptions(friendJson) {
      this.friendOptions = friendJson
      localStorage.setItem("friendOptions",JSON.stringify(friendJson))
    },
    setFriendOpenGame(friendJson) {
      this.friendOpenGame = friendJson
      localStorage.setItem("friendOpenGame",JSON.stringify(friendJson))
    },
    setAudioCanBeHeard(audioCanBeHeard) {
      this.audioCanBeHeard = audioCanBeHeard
    },
    setStartOnLandingPage(startOnLandingPage) {
      this.startOnLandingPage = startOnLandingPage
      localStorage.setItem("startOnLandingPage",startOnLandingPage)
    },
    setRunRequestFromLandingPage(runRequestFromLandingPage) {
      console.log("set run request",runRequestFromLandingPage)
      this.runRequestFromLandingPage = runRequestFromLandingPage
      localStorage.setItem("runRequestFromLandingPage",runRequestFromLandingPage)
    },
    setToolbarHeight(toolbarHeight) {
      this.toolbarHeight = toolbarHeight
      localStorage.setItem("toolbarHeight","" + toolbarHeight)
    },
    setMicrophoneIsMuted(isMuted) {
      this.microphoneIsMuted = isMuted
    },
    setEmailAddress(email) {
      this.email = email
      localStorage.setItem("email","" + email)
    },
    setIsMe(isMeFlag) {
      this.isMe = isMeFlag
      localStorage.setItem("isMe","" + isMeFlag)
    },
    setCanPerpetual(canPerpetualFlag) {
      this.canPerpetual = canPerpetualFlag
      localStorage.setItem("canPerpetual","" + canPerpetualFlag)
    },
    setPlayerMp3(playerName,playerLang,playerVendor) {
      this.playerMp3Name = playerName
      this.playerMp3Lang = playerLang
      this.playerMp3Vendor = playerVendor
      localStorage.setItem("playerMp3Name",playerName)
      localStorage.setItem("playerMp3Lang",playerLang)
      localStorage.setItem("playerMp3Vendor",playerVendor)
    },
    setOpponentMp3(opponentName,opponentLang,opponentVendor) {
      this.opponentMp3Name = opponentName
      this.opponentMp3Lang = opponentLang
      this.opponentMp3Vendor = opponentVendor
      localStorage.setItem("opponentMp3Name",opponentName)
      localStorage.setItem("opponentMp3Lang",opponentLang)
      localStorage.setItem("opponentMp3Vendor",opponentVendor)
    },
    setUserCookieDummy(cookie,dummy) {
      //console.log("in setUserCookieDummy",cookie,dummy)
      this.cookie = cookie
      localStorage.setItem("cookie",cookie)
      this.dummy = dummy
      localStorage.setItem("dummy",dummy)

      // zero out all the other fields on a setting of cookie & dummy. will reload from server
      this.lastStartupCheckDate = null
      this.isSubscriber = null
      this.subscriberExpireDate = null
      this.subscriberExpireDisplayString = null
      this.isMe = null
      this.verified = null

      localStorage.removeItem("isSubscriber")
      localStorage.removeItem("lastStartupCheckDate")
      localStorage.removeItem("subscriberExpireDate")
      localStorage.removeItem("subscriberExpireDisplayString")
      localStorage.removeItem("isMe")
      localStorage.removeItem("emailVerified")
    },
    setPlayType(playType) {
      this.playType = playType
      localStorage.setItem("playType",playType)
    },
    setEmailVerified(verified) {
      this.verified = verified
      localStorage.setItem("emailVerified","" + verified)
    },
    setLastStartupDate(startupDate) {
      this.lastStartupCheckDate = startupDate
      localStorage.setItem("lastStartupCheckDate","" + startupDate)
    },
    setLichessAccessToken(token) {
      this.lichessAccessToken = token
      localStorage.setItem("lichessAccessToken",token)
    },
    setLichessUserid(userid) {
      this.lichessUserid = userid
      localStorage.setItem("lichessUserid",userid)
    },
    setPlayComputerGameId(playComputerGameId) {
      this.playComputerGameId = playComputerGameId
      localStorage.setItem("playComputerGameId","" + playComputerGameId)
    },
    setReviewGameId(reviewGameId) {
      this.reviewGameId = reviewGameId
      localStorage.setItem("reviewGameId","" + reviewGameId)
    },
    setLichessGameId(lichessGameId) {
      this.lichessGameId = lichessGameId
      localStorage.setItem("lichessGameId",lichessGameId)
    },
    setLichessFriend(friendId,friendName) {
      this.lichessFriendId = friendId
      this.lichessFriendName = friendName
      localStorage.setItem("lichessFriendId",friendId)
      localStorage.setItem("lichessFriendName",friendName)
    },
    setVerbalHomePage(verbalHomePage) {
      this.verbalHomePage = verbalHomePage
      localStorage.setItem("verbalHomePage",verbalHomePage)
    },
    setLanguageInUse(languageInUse) {
      this.languageInUse = languageInUse
      localStorage.setItem("languageInUse",languageInUse)
    },
    setLanguageIncludingSystem(language) {
      this.languageIncludingSystem = language
      localStorage.setItem("languageIncludingSystem",language)
    },
    setDeviceType(deviceType) {
      this.deviceType = deviceType
      localStorage.setItem("deviceType",deviceType)
    },
    setDarkMode(darkmode) {
      this.darkmode = darkmode
      localStorage.setItem("dark",darkmode)
    },
    setBoardColors(boardColors) {
      this.boardColors = boardColors
      localStorage.setItem("boardColors",boardColors)
    },
    setCoordinateLocation(coordinateLocation) {
      this.coordinateLocation = coordinateLocation
      localStorage.setItem("coordinateLocation","" + coordinateLocation)
    },
    setSeenTour(seenTour) {
      this.seenTour = seenTour
      localStorage.setItem("seenTour","" + seenTour)
    },
     setPreviouslySeenProgramVersion(previouslySeenProgramVersion) {
      this.previouslySeenProgramVersion = previouslySeenProgramVersion
      localStorage.setItem("previouslySeenProgramVersion","" + previouslySeenProgramVersion)
    },
    setFileWords(fileWords) {
      this.fileWords = fileWords
      localStorage.setItem("fileWords","" + fileWords)
    },
    setIsSubscriber(isSubscriber) {
      this.isSubscriber = isSubscriber
      localStorage.setItem("isSubscriber","" + isSubscriber)
    },
    setSubscriberExpireDate(subscriberExpireDate) {
      this.subscriberExpireDate = subscriberExpireDate
      localStorage.setItem("subscriberExpireDate","" + subscriberExpireDate)
    },
    setSubscriberExpireDisplayString(subscriberExpireDisplayString) {
      this.subscriberExpireDisplayString = subscriberExpireDisplayString
      localStorage.setItem("subscriberExpireDisplayString",subscriberExpireDisplayString)
    },
  }

})
